export function not(value: any) {
	return !value;
}
